"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

require("../../../stylesheets/components/common/MessageContainer.css");

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _reactTransitionGroup = require("react-transition-group");

var _Flash = _interopRequireDefault(require("../../../components/common/Flash"));

var _Propulator = _interopRequireDefault(require("../../../higher-order/Propulator"));

var _mobx = require("mobx");

var _map = _interopRequireDefault(require("lodash/map"));

var _mobxReact = require("mobx-react");

var _class;

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

var MessageContainer = (0, _mobxReact.observer)(_class = /*#__PURE__*/function (_React$Component) {
  _inherits(MessageContainer, _React$Component);

  var _super = _createSuper(MessageContainer);

  function MessageContainer(props) {
    _classCallCheck(this, MessageContainer);

    return _super.call(this, props);
  }

  _createClass(MessageContainer, [{
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      if (this.props.containerId) {
        this.props.dispatcher.emit("CLEAR_FLASH_MESSAGES", {
          containerId: this.props.containerId
        });
      }
    }
  }, {
    key: "render",
    value: function render() {
      var messages = this.props.containerId ? this.props.localizedMessages.get(this.props.containerId) : this.props.messages;
      var cssClass = "message-container";

      if (this.props.type === "flash") {
        cssClass = "flash-container";
      }

      return /*#__PURE__*/_react.default.createElement("div", {
        className: cssClass
      }, /*#__PURE__*/_react.default.createElement(_reactTransitionGroup.TransitionGroup, null, messages && (0, _map.default)(messages, function (m) {
        return /*#__PURE__*/_react.default.createElement(_reactTransitionGroup.CSSTransition, {
          key: m.id || m.messageId,
          classNames: "flash",
          timeout: 500
        }, /*#__PURE__*/_react.default.createElement(_Flash.default, m));
      })));
    }
  }]);

  return MessageContainer;
}(_react.default.Component)) || _class;

MessageContainer.propTypes = {
  //TODO: Investigate proper prop type - always should be an ObservableArray
  messages: _mobxReact.PropTypes.arrayOrObservableArray,
  type: _propTypes.default.string,
  transitionTimeout: _propTypes.default.number,
  containerId: _propTypes.default.string
};
MessageContainer.defaultProps = {
  messages: (0, _mobx.observable)([]),
  type: "flash",
  transitionTimeout: 400
};

var _default = (0, _Propulator.default)(MessageContainer, {
  messageStore: ["messages", "localizedMessages"]
});

exports.default = _default;